import { render, staticRenderFns } from "./_DoRadio.vue?vue&type=template&id=4d97c511&scoped=true"
import script from "./_DoRadio.vue?vue&type=script&lang=js"
export * from "./_DoRadio.vue?vue&type=script&lang=js"
import style0 from "./_DoRadio.vue?vue&type=style&index=0&id=4d97c511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97c511",
  null
  
)

export default component.exports